import {FC} from "react"

import {TabButton} from "@frontend/components"
import {useTranslation} from "@frontend/i18n"
import {makePath} from "@frontend/routing"
import {trackEvent} from "@frontend/utils/trackEvent"
import {css, cx} from "@styled-system/css"
import {hstack} from "@styled-system/patterns"

import {TABS, useCurrentTab} from "../util/tabs"

interface Props {
  caseId: string
  causeOnMessageId: number
  className?: string
}

export const Tabs: FC<Props> = ({caseId, causeOnMessageId, className}) => {
  const currentTab = useCurrentTab()
  const t = useTranslation()

  return (
    <div
      className={hstack({
        justifyContent: "space-between",
        marginX: 0,
        zIndex: 1,
        largeDesktop: {
          gap: 32,
        },
      })}
    >
      <div
        className={cx(
          hstack({
            gap: {base: 24, largeDesktop: 32},
            position: "relative",
            desktopDown: {
              width: "100%",
              paddingX: 24,
              height: 46,
              _after: {
                content: '""',
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                height: 4,
                width: "100%",
                zIndex: -1,
                backgroundColor: "#C6CFE2",
              },
            },
          }),
          className,
        )}
      >
        {TABS.map((tab) => (
          <TabButton
            navigateTo={makePath({
              name: "cases",
              caseId,
              causeOnMessageId,
              diy: tab,
            })}
            key={tab}
            title={t(`cause.diy.tabs.${tab}`)}
            active={tab === currentTab}
            onClick={() =>
              trackEvent(
                tab === "steps"
                  ? "diy_repair_guide"
                  : tab === "videos"
                    ? "diy_videos"
                    : "diy_documents",
              )
            }
            className={css({
              minWidth: "fit-content",
              height: "100%",
            })}
          />
        ))}
      </div>
    </div>
  )
}
